export default "__VITE_PUBLIC_ASSET__6cf8823b__"